// REFACTOR remover e utilizar a constante src/app/config/calendar_type.js
export const TYPE_CALENDAR = {
  EVERY: 1, // a cada
  TIMES_PER: 2, // vezes por
  PER_SHIFT: 3 // por turno
};
